const WhatsappFloater = () => (
  <div className="fixed bottom-4 right-4 cursor-pointer z-[1000]">
    <div className="relative flex flex-col items-center">
      <div className="relative">
        <img src="/whatsapp.svg" alt="Whatsapp" onClick={() => window.open('https://wa.me/542645515045?text=¡Hola!%20Necesito%20ayuda%20para%20darme%20de%20alta%20en%20Avantti', '_blank')} />
        <div className="absolute top-2 right-2 h-3 w-3 transform -translate-y-1/2 translate-x-1/2 rounded-full bg-red-600" />
      </div>
              <span className="text-xs text-text-secondary mt-2 text-center whitespace-nowrap bg-surface-base px-2 py-1 rounded-lg shadow-lg">¿Necesitas ayuda?</span>
    </div>
  </div>
);

export default WhatsappFloater;
